<template>
  <section>
    <nav class="columns">
      <div class="column">
        <b-field grouped group-multiline>
          <b-field>
            <b-select
              v-model="selectedArea"
              :loading="loadingAreas"
              :placeholder="$t('message.please_select') + $t('attributes.area')"
              @input="onSelectArea"
            >
              <option value="">
                {{ $t('attributes.all_area') }}
              </option>
              <option
                v-for="option in areas"
                :value="option"
                :key="option.code"
              >
                {{ !option.status ? '[下架]' : '' }}
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field>
            <b-select
              v-model="selectedCatalog"
              :loading="loadingAreas"
              :disabled="catalogs.length <= 0"
              :placeholder="
                $t('message.please_select') + $t('attributes.catalog')
              "
              @input="onSelectCatalog"
            >
              <option value="">全部類別</option>
              <option
                v-for="option in catalogs"
                :value="option"
                :key="option.catalog_no"
              >
                {{ !option.status ? '[下架]' : '' }}
                {{ option.name }}
              </option>
            </b-select>
          </b-field>
          <b-field>
            <p class="control">
              <span class="button is-static">
                {{ $t('attributes.activation_status') }}
              </span>
            </p>
            <b-select v-model="filterStatus" @input="onFilterStatus">
              <option value="all">{{ $t('attributes.all') }}</option>
              <option value="true">{{ $t('attributes.enabled') }}</option>
              <option value="false">{{ $t('attributes.disabled') }}</option>
            </b-select>
          </b-field>
          <b-field>
            <b-input
              v-model="searchName"
              :placeholder="$t('attributes.search') + $t('attributes.name')"
              type="search"
              icon="magnify"
              @input="onFilter"
            ></b-input>
          </b-field>
        </b-field>
      </div>

      <div class="column is-3 is-2-desktop">
        <div class="buttons is-right">
          <b-button
            :loading="sending"
            class="is-primary"
            icon-left="plus"
            @click="onAdd"
          >
            {{ $t('attributes.add') + $t('attributes.banner') }}
          </b-button>
        </div>
      </div>
    </nav>

    <b-table
      :data="items"
      :loading="isLoading"
      :selected.sync="selectedItem"
      :mobile-cards="false"
      :row-class="setRowClass"
      hoverable
      narrowed
      bordered
      paginated
      pagination-position="both"
      backend-pagination
      backend-sorting
      :current-page="parseInt(page)"
      :total="total"
      :per-page="perPage"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      @page-change="onPageChange"
      @sort="onSort"
      @select="onSelected"
    >
      <b-table-column
        field="start_date"
        :label="$t('attributes.start_date')"
        width="120"
        sortable
        centered
        v-slot="props"
        >{{
          props.row.catalog_banner_start != null
            ? props.row.catalog_banner_start.split('T')[0]
            : props.row.catalog_banner_start
        }}
      </b-table-column>

      <b-table-column
        field="end_date"
        :label="$t('attributes.end_date')"
        width="120"
        sortable
        centered
        v-slot="props"
        >{{
          props.row.catalog_banner_end != null
            ? props.row.catalog_banner_end.split('T')[0]
            : props.row.catalog_banner_end
        }}
      </b-table-column>

      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="75"
        sortable
        centered
        v-slot="props"
      >
        <b-tag
          :type="props.row.status ? 'is-info' : 'is-danger'"
          size="is-medium"
        >
          {{ activeStatus(props.row.status) }}
        </b-tag>
      </b-table-column>

      <b-table-column
        :label="$t('attributes.picture')"
        width="120"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.picture"
          :href="CatalogBannerImage(props.row.picture)"
          @click.prevent="onClickImage(props.row.picture)"
        >
          <figure class="image">
            <img
              :src="CatalogBannerImage(props.row.picture)"
              :alt="props.row.picture_alt"
              style="width: 120px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>

      <b-table-column
        :label="$t('attributes.mobile_picture')"
        width="120"
        centered
        v-slot="props"
      >
        <a
          v-if="props.row.mobile_picture"
          :href="CatalogBannerImage(props.row.mobile_picture)"
          @click.prevent="onClickImage(props.row.mobile_picture)"
        >
          <figure class="image">
            <img
              :src="CatalogBannerImage(props.row.mobile_picture)"
              :alt="props.row.picture_alt"
              style="width: 64px; margin: auto;"
            />
          </figure>
        </a>
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        sortable
        width="200"
        v-slot="props"
      >
        <p v-html="props.row.name"></p>
      </b-table-column>

      <b-table-column
        field="catalog"
        :label="$t('attributes.catalog')"
        sortable
        width="300"
        v-slot="props"
      >
        <p
          :title="props.row.catalog_names"
          v-html="
            props.row.catalog_names.length > 98
              ? props.row.catalog_names.substring(0, 98) + '......'
              : props.row.catalog_names
          "
        ></p>
      </b-table-column>

      <b-table-column
        field="has_video"
        :label="$t('attributes.has_video')"
        width="120"
        sortable
        centered
        v-slot="props"
      >
        {{ whetherStatus(props.row.has_video) }}
      </b-table-column>

      <b-table-column
        field="url"
        :label="$t('attributes.url')"
        width="75"
        centered
        v-slot="props"
      >
        <a v-if="props.row.url" :href="props.row.url" target="_blank">
          {{ props.row.has_video ? '影片連結' : '外連' }}
        </a>
      </b-table-column>

      <b-table-column
        field="update_at"
        :label="$t('attributes.gift_updated_at')"
        sortable
        centered
        width="120"
        v-slot="props"
      >
        {{ formatDateTime(props.row.updated_at) }}
      </b-table-column>

      <b-table-column :width="165" label="功能" centered v-slot="props">
        <div class="buttons">
          <b-button type="is-success" @click.prevent="onSync(props.row)">
            {{ $t('attributes.sync') }}
          </b-button>
          <b-button type="is-danger" @click.prevent="onDelete(props.row)">
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div
            v-if="!loadingItems"
            class="content has-text-grey has-text-centered"
          >
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <section id="content" style="min-height: 400px; margin-top:40px;">
      <b-tabs
        v-if="selectedItem"
        :animated="false"
        class="boarder-tabs"
        destroyOnHide
        multiline
        expanded
      >
        <b-tab-item :disabled="sending">
          <banner-form :banner="selectedItem" @send="updateItem" />
        </b-tab-item>
      </b-tabs>
    </section>

    <b-modal
      :active.sync="isCreateFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1650"
      has-modal-card
    >
      <banner-create-form
        :area-code="selectedAreaCode"
        @onCreate="createItem"
      />
    </b-modal>

    <b-modal
      :active.sync="isBannerSyncFormModelActive"
      :can-cancel="['escape', 'x']"
      :width="800"
      has-modal-card
    >
      <banner-sync-form :banner="selectedBanner" @send="syncBanner" />
    </b-modal>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { AREA_API, CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import BannerForm from './BannerForm'
import BannerCreateForm from '@/components/catalogs/BannerCreateForm'
import BannerSyncForm from '@/components/catalogs/BannerSyncForm'
import debounce from 'lodash/debounce'

export default {
  name: 'BannerList',
  components: { BannerCreateForm, BannerForm, BannerSyncForm },

  props: {
    query: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loadingItems: false,
      total: 0,
      items: [],
      selectedItem: null,

      filterStatus: this.query.status || 'true',
      searchName: this.query.name || '',
      sortField: this.query.sort || 'update_at',
      sortOrder: this.query.order || 'desc',
      defaultSortOrder: 'desc',
      page: this.query.page || 1,
      perPage: this.query.page_size || 10,

      loadingAreas: false,
      areas: [],
      catalogs: [],
      selectedArea: null,
      selectedAreaCode: this.query.ac || null,
      selectedCatalog: null,
      selectedCatalogNo: this.query.cn || null,

      isCreateFormModalActive: false,
      sending: false,

      isBannerSyncFormModelActive: false,
      selectedBanner: null,

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  watch: {
    query(query) {
      this.getQuery(query)
      this.loadItems()
    },
    selected(item) {
      this.selectedItem = item
    }
  },
  computed: {
    isLoading() {
      return this.loadingAreas || this.loadingItems
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.catalogs = []
        this.selectedArea = null
        this.selectedCatalog = null

        if (this.selectedAreaCode) {
          this.selectedArea = areas.find(a => a.code === this.selectedAreaCode)
          this.catalogs = this.selectedArea
            ? this.selectedArea.catalogs.sort(c => c.sort)
            : []
        }
        if (this.selectedCatalogNo) {
          this.selectedCatalog = this.catalogs.find(
            c => c.catalog_no === this.selectedCatalogNo
          )
        }

        if (this.selectedArea) {
          await this.loadItems()
        }
      } catch (e) {
        this.areas = []
        this.catalogs = []
        this.selectedArea = null
        this.selectedAreaCode = null
        this.selectedCatalog = null
        this.selectedCatalogNo = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    async loadItems() {
      try {
        this.selectedItem = null
        const api = `${CATALOG_API}/banners`
        const params = {
          area_code: this.selectedAreaCode,
          catalog_no: this.selectedCatalogNo,
          search: this.searchName,
          active:
            this.filterStatus !== 'all' ? this.filterStatus === 'true' : null,
          sort_by: this.sortField,
          by_descending: this.sortOrder !== 'asc',
          page_size: this.perPage,
          page_number: this.page
        }

        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        const data = res.data.data

        this.items = data.items
        this.total = data.item_count
      } catch (e) {
        this.items = []
        this.total = 0

        notifyService.fetch_error('banner', e)
      } finally {
        this.loadingItems = false
      }
    },
    getQuery(query) {
      this.filterStatus = query.status || 'true'
      this.searchName = query.name
      this.sortField = query.sort || 'update_at'
      this.sortOrder = query.order || 'desc'
      this.page = query.page || 1
      this.perPage = query.page_size || 10

      this.selectedArea = null
      this.selectedCatalog = null
      this.selectedAreaCode = query.ac || null
      this.selectedCatalogNo = query.cn || null

      if (this.selectedAreaCode) {
        this.selectedArea = this.areas.find(
          a => a.code === this.selectedAreaCode
        )
        this.catalogs = this.selectedArea
          ? this.selectedArea.catalogs.sort(c => c.sort)
          : []
      }
      if (this.selectedCatalogNo) {
        this.selectedCatalog = this.catalogs.find(
          c => c.catalog_no === this.selectedCatalogNo
        )
      }
    },
    updateQuery() {
      const query = {
        status: this.filterStatus,
        name: this.searchName,
        ac: this.selectedAreaCode,
        cn: this.selectedCatalogNo,
        sort: this.sortField,
        order: this.sortOrder,
        page_size: this.perPage.toString(),
        page: this.page.toString()
      }

      Object.keys(query).forEach(key => !query[key] && delete query[key])

      this.$router
        .push({
          name: this.$route.name,
          query: query
        })
        .catch(() => {})
    },
    onFilter: debounce(function() {
      this.updateQuery()
      this.loadItems()
    }, 500),
    onFilterStatus() {
      this.updateQuery()
    },
    onSelectArea(option) {
      this.selectedArea = option
      this.selectedAreaCode = option ? option.code : null
      this.catalogs = option ? option.catalogs.sort(c => c.sort) : []
      this.selectedCatalog = null
      this.selectedCatalogNo = null

      this.updateQuery()
    },
    onSelectCatalog(option) {
      this.selectedCatalog = option
      this.selectedCatalogNo = option ? option.catalog_no : null

      this.updateQuery()
    },
    onPageChange(page) {
      this.page = page
      this.selectedItem = null
      this.updateQuery()
    },
    onSelected() {
      this.$scrollTo(`#content`, { offset: -60 })
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.selectedItem = null
      this.updateQuery()
    },
    setRowClass(row) {
      if (!row.status) {
        return 'is-off'
      } else {
        return this.checkDateValid(
          row.catalog_banner_start,
          row.catalog_banner_end
        )
          ? 'is-valid'
          : 'is-invalid'
      }
    },
    checkDateValid(start_date, end_date) {
      const nowDate = new Date()
      return (
        Date.parse(start_date) <= nowDate && Date.parse(end_date) >= nowDate
      )
    },
    onAdd() {
      this.isCreateFormModalActive = true
    },
    onSync(item) {
      this.selectedBanner = item
      this.isBannerSyncFormModelActive = true
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteItem(item)
        }
      })
    },
    async createItem(item) {
      try {
        const api = `${CATALOG_API}/banners`
        this.sending = true
        await this.axios.post(api, item)
        this.isFormModalActive = false
        notifyService.success(this.$t('attributes.add_succeed'))

        await this.loadItems()
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async updateItem(item) {
      try {
        const api = `${CATALOG_API}/banners/${item.id}`
        this.sending = true
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        const idx = this.items.findIndex(s => s.id === _item.id)
        const items = [...this.items]
        items[idx] = _item
        this.items = items.sort((t1, t2) => t1.sort - t2.sort)
        this.selectedItem = this.items.find(t => t.id === item.id)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async syncBanner(data) {
      try {
        const api = `${CATALOG_API}/banners/sync/${data.id}`
        this.sending = true
        await this.axios.put(api, data)
        notifyService.success(this.$t('attributes.update_succeed'))

        await this.loadItems()
        this.isBannerSyncFormModelActive = false
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteItem(item) {
      try {
        const api = `${CATALOG_API}/banners/${item.id}`

        this.sending = true
        await this.axios.delete(api)
        notifyService.success(this.$t('attributes.delete_succeed'))

        await this.loadItems()
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = this.CatalogBannerImage(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.b-table {
  margin-top: 0.75rem;

  td {
    vertical-align: middle;
  }
}
</style>
